import React, { useRef, useState, ChangeEvent } from 'react';
import { CloudUpload } from '@material-ui/icons';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Tooltip, IconButton, Typography } from '@material-ui/core';
import { useHistory } from 'react-router';
import { loginChecker } from '../../utils/login-controler';

interface FileUploadProps {
  onFileSelect: (file: File | '') => void;
  accept?: string;
  setIsError: (value: boolean) => void;
  setIsSuccess: (value: boolean) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    },
    fileDisplay: {
      width: 150,
      maxWidth: 200,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
    },
    hiddenInput: {
      display: 'none',
    },
  })
);

const FileUploadButton: React.FC<FileUploadProps> = ({ 
  onFileSelect,
  accept = '.csv',
  setIsError,
  setIsSuccess
}) => {
  const classes = useStyles();
  const history = useHistory();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFileName, setSelectedFileName] = useState('');

  const handleClick = () => {
    if (loginChecker(history)) return;

    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    const file = files && files.length > 0 ? files[0] : '';
    
    setIsError(false);
    setIsSuccess(false);

    setSelectedFileName(file ? file.name : '');
    onFileSelect(file);
  };

  return (
    <div className={classes.container}>
      <input
        type="file"
        accept={accept}
        ref={inputRef}
        className={classes.hiddenInput}
        onChange={handleChange}
      />
      <IconButton onClick={handleClick}>
        <CloudUpload />
      </IconButton>
      {selectedFileName && (
        <Tooltip title={selectedFileName}>
          <Typography className={classes.fileDisplay}>{selectedFileName}</Typography>
        </Tooltip>
      )}
    </div>
  );
};

export default FileUploadButton;
